module.exports = __webpack_public_path__ + "static/img/instrument.1ca8fea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/nav/instrument.png
// module id = +l/s
// module chunks = 0